<template>
  <div class="App">
    <section class="section1">
      <img
        v-if="!bgImgNotFound"
        class="img"
        alt="banner"
        :src="bg1"
        @error="onImgNotFound"
      />
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        width="744.20012"
        height="551.74925"
        viewBox="0 0 744.20012 551.74925"
        role="img"
        class="img"
      >
        <polygon
          points="356.109 197.381 93.963 197.381 45.233 251.661 45.233 197.381 0 197.381 0 0 356.109 0 356.109 197.381"
          fill="#e5e5e5"
        />
        <rect
          x="58.39262"
          y="57.98108"
          width="239.32463"
          height="10.69151"
          fill="#fff"
        />
        <rect
          x="58.39262"
          y="93.34512"
          width="239.32463"
          height="10.69151"
          fill="#fff"
        />
        <rect
          x="58.39262"
          y="128.70925"
          width="239.32463"
          height="10.69151"
          fill="#fff"
        />
        <circle cx="45.95397" cy="275.88382" r="9" fill="#e6e6e6" />
        <polygon
          points="628.598 540.263 618.514 540.263 613.716 501.367 628.599 501.367 628.598 540.263"
          fill="#9f616a"
        />
        <path
          d="M859.06937,724.16364l-32.51549-.0012v-.41127a12.65661,12.65661,0,0,1,12.65593-12.65574h.00081l19.85935.00081Z"
          transform="translate(-227.89994 -174.12538)"
          fill="#2f2e41"
        />
        <polygon
          points="530.313 539.464 520.752 536.259 528.567 497.855 542.678 502.586 530.313 539.464"
          fill="#9f616a"
        />
        <path
          d="M757.54434,723.67536,726.71552,713.339l.13072-.38994a12.65662,12.65662,0,0,1,16.02229-7.97663l.00077.00026,18.82917,6.31318Z"
          transform="translate(-227.89994 -174.12538)"
          fill="#2f2e41"
        />
        <path
          d="M770.64407,513.37,748.80679,698.09923l21.418,1.80638s33.69049-181.62307,44.07687-160.10837,23.112,156.07642,23.112,156.07642h21.25667S864.1215,485.92037,841.865,475.534Z"
          transform="translate(-227.89994 -174.12538)"
          fill="#2f2e41"
        />
        <circle
          cx="806.06089"
          cy="357.44533"
          r="21.51465"
          transform="matrix(0.1735, -0.98483, 0.98483, 0.1735, 86.28294, 915.13779)"
          fill="#9f616a"
        />
        <path
          d="M793.2715,386.87877l27.44975,2.22561s21.88557.37095,30.78819,6.306-8.53166,42.65838-8.53166,42.65838-4.5325,14.56-1.11281,21.14369c11.09589,21.36213,9.45082,37.81286,9.45082,37.81286s-22.80474,5.21641-62.12459,15.60281c0,0-24.4822,9.6445-23.74029,4.45131s8.16075-64.54394,8.16075-64.54394v-61.5764Z"
          transform="translate(-227.89994 -174.12538)"
          fill="#3f3d56"
        />
        <path
          d="M841.29052,355.11546c-1.09826-6.12676-3.55843-14.818-9.03927-21.40759.1727.001.3446.00858.5173.00356,1.88364-.055,4.02694-.64908,4.80509-2.36519a4.10439,4.10439,0,0,0-.75145-4.094,12.08637,12.08637,0,0,0-3.4291-2.67941c1.32176.8025,3.19014,1.54787,4.24542.41749a2.2903,2.2903,0,0,0,.25865-2.44517,6.06575,6.06575,0,0,0-1.64889-1.98907,40.545,40.545,0,0,0-7.24981-5.11575c-2.01015-1.11065-4.65448-2.00252-6.459-.58176-1.83826,1.44737-1.54306,4.2658-1.07074,6.55735a7.5434,7.5434,0,0,0-3.3773-1.01918,2.586,2.586,0,0,0-2.59051,1.99022,2.65621,2.65621,0,0,0,1.19685,2.32c-7.09357-1.16653-16.15754.15709-27.74534,5.51874,0,0-11.23558,3.74519-11.80629,18.53563a26.23857,26.23857,0,0,0,.78,7.02324c.633,2.68118,2.8849,15.83463.18395,21.15044l13.53088,4.82116.155-8.105c-10.51625-15.18027-5.32118-20.75087-1.22657-29.88095a.09651.09651,0,0,1,.1723-.013c.75667,1.29842,3.65643,5.74912,13.63531,5.74912l-3.856-3.85614s16.96683,6.94106,23.13665,6.94106c0,0,4.62717,3.08486,0,7.71223s-14.75464,11.43825-9.356,19.92171,4.93362,11.49322,4.93362,11.49322l12.33965-6.941s7.537-14.912,8.87359-19.30325A22.14974,22.14974,0,0,0,841.29052,355.11546Z"
          transform="translate(-227.89994 -174.12538)"
          fill="#2f2e41"
        />
        <polygon
          points="465.118 348.182 710.597 348.182 710.597 484.244 679.416 484.244 679.416 521.661 645.825 484.244 465.118 484.244 465.118 348.182"
          fill="#6c63ff"
          class="theme-fill"
        />
        <rect
          x="505.36955"
          y="388.15013"
          width="164.97534"
          height="7.37006"
          fill="#fff"
        />
        <rect
          x="505.36955"
          y="412.52788"
          width="164.97534"
          height="7.37006"
          fill="#fff"
        />
        <rect
          x="505.36955"
          y="436.90569"
          width="164.97534"
          height="7.37006"
          fill="#fff"
        />
        <path
          d="M854.19849,435.12524l-14.39822,3.5-.109,29.1399-16.19429,55.89392a9.04684,9.04684,0,1,0,14.21707,4.30557l19.35953-57.86281Z"
          transform="translate(-227.89994 -174.12538)"
          fill="#9f616a"
        />
        <path
          d="M758.36916,434.51257l17.27327,4.93522.109,29.1399,16.19429,55.89392a9.04684,9.04684,0,1,1-14.21707,4.30557l-19.35953-57.86282Z"
          transform="translate(-227.89994 -174.12538)"
          fill="#9f616a"
        />
        <path
          d="M832.5914,392.44289l3.56817-1.16349a8.11967,8.11967,0,0,1,6.07635.42161h0s10.38638.74188,11.87015,8.16073,5.09242,72.2635,5.09242,72.2635l-22-7Z"
          transform="translate(-227.89994 -174.12538)"
          fill="#3f3d56"
        />
        <path
          d="M782.51422,392.44289l-6.31573-.31765-2-1s-11.71517,1.31765-13.19894,8.7365-5.80106,74.2635-5.80106,74.2635l22-6Z"
          transform="translate(-227.89994 -174.12538)"
          fill="#3f3d56"
        />
        <path
          d="M419.67568,655.2772l10.428-9.09653a174.18428,174.18428,0,0,0-2.4387-19.48056l-5.7548,2.43463,5.33914-4.65743c-1.53637-7.95184-3.05724-13.12045-3.05724-13.12045s-21.04,18.68386-32.81374,41.47657l5.16485,16.98969-7.88893-11.23455a70.472,70.472,0,0,0-2.99821,8.33272c-8.20952,28.63806-5.51167,54.535,6.026,57.84251s27.54593-17.22709,35.75548-45.86511a92.77564,92.77564,0,0,0,2.89164-28.12863Z"
          transform="translate(-227.89994 -174.12538)"
          fill="#f1f1f1"
        />
        <path
          d="M447.28951,677.545l13.62889-2.39683a174.17966,174.17966,0,0,0,7.98189-17.9368l-6.18489-.89046,6.978-1.22712c2.79511-7.60129,4.16481-12.812,4.16481-12.812s-27.66878,5.11864-49.52926,18.54432l-4.36053,17.21363-.9461-13.6951a70.46339,70.46339,0,0,0-6.87381,5.58343C390.31773,690.2,379.241,713.76358,387.40819,722.55871s32.4852-.50861,54.31606-20.78054a92.77308,92.77308,0,0,0,17.01509-22.58464Z"
          transform="translate(-227.89994 -174.12538)"
          fill="#f1f1f1"
        />
        <path
          d="M971.10006,725.12524h-618a1,1,0,0,1,0-2h618a1,1,0,0,1,0,2Z"
          transform="translate(-227.89994 -174.12538)"
          fill="#cbcbcb"
        />
      </svg>
      <div class="content">
        <p
          class="d-flex align-items-center"
          style="column-gap: 0.5rem; font-size: 14px"
        ></p>
        <h1 class="theme-color">{{ title }}</h1>
        <p class="text-darkgray">
          {{ introductionText }}
        </p>
        <div class="buttons">
          <b-button variant="primary" :to="'/' + Routes['report'][$i18n.locale]"
            >Denunciar
          </b-button>
          <b-button
            v-if="hasDocumentsSection"
            variant="link"
            href="#leiturasImportantes"
            class="theme-color"
            >Documentos de Referência<i class="fas fa-arrow-right fa-1-5x"
          /></b-button>
        </div>
      </div>
    </section>
    <section class="section3">
      <p class="text-darkgray" v-html="instructionText"></p>
    </section>
    <section id="consultar" class="section2">
      <div>
        <div class="content">
          <h1>Acompanhe a sua denúncia:</h1>
        </div>
        <div class="form">
          <b-input-group class="protocol-input">
            <b-input
              v-model="protocol"
              placeholder="Insira o número do protocolo"
            ></b-input>
            <b-button
              variant="primary"
              :to="`/${Routes['follow-up'][$i18n.locale]}/${protocol}`"
              >Buscar</b-button
            >
          </b-input-group>
        </div>
      </div>
    </section>
    <section
      v-if="hasDocumentsSection"
      id="leiturasImportantes"
      class="section5"
    >
      <div class="content">
        <h1>Documentos de <strong>Referência</strong></h1>
        <p>
          Aqui você encontra documentos institucionais da organização,
          disponíveis para consulta.
        </p>
      </div>
      <div class="details">
        <div v-for="file in files" :key="file.title" class="file-entry">
          <b-avatar variant="primary" class="position-relative">
            <i v-if="file.icon" :class="file.icon" />
            <template v-else>
              <i
                v-for="icon in file.icons"
                :key="icon.class"
                :class="icon.class"
                :style="icon.style"
              />
            </template>
          </b-avatar>
          <h3>
            {{ file.title }}
            <b-button
              variant="link"
              class="theme-color"
              target="_blank"
              :to="file.url"
              >Baixar arquivo <i class="fa fa-arrow-down"
            /></b-button>
          </h3>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Routes } from "@/i18n";

export default {
  name: "CompanyHome",
  computed: {
    ...mapGetters(["company", "portal", "portalBucket"]),
    logo() {
      return `https://${this.portalBucket}/${this.portal._id}/${this.portal?.logo}`;
    },
    bg1() {
      return `https://${this.portalBucket}/${this.portal._id}/bg1.png`;
    },
    bg1Style() {
      const bg = `url(${this.bg1})`;
      return `background-image: ${bg}`;
    },
    bg2() {
      return `https://${this.portalBucket}/${this.portal._id}/bg2.png`;
    },
    bg2Style() {
      const bg = `url(${this.bg2})`;
      return `background-image: ${bg}`;
    },
    hasDocumentsSection() {
      return Object.keys(this.company.compliance?.files || {}).length > 0;
    },
    files() {
      const entries = [];

      for (const file of this.company.compliance?.files || []) {
        console.log(file);
        entries.push({
          title: file.name,
          url: `/download/${file._id}`,
          icon: "fa fa-file",
        });
      }
      return entries;
    },
    title() {
      const lang = this.$i18n.locale;
      const portal = this.portal;
      if (
        portal &&
        portal.languages &&
        portal.languages[lang] &&
        portal.languages[lang].title
      )
        return portal.languages[lang].title;
      return this.$i18n.t("home.title", [this.company.fantasyName]);
    },
    introductionText() {
      const lang = this.$i18n.locale;
      const portal = this.portal;
      if (
        portal &&
        portal.languages &&
        portal.languages[lang] &&
        portal.languages[lang].introductionText
      )
        return portal.languages[lang].introductionText;
      return this.$i18n.t("home.introductionText", [this.company.fantasyName]);
    },
    instructionText() {
      const lang = this.$i18n.locale;
      const portal = this.portal;
      if (
        portal &&
        portal.languages &&
        portal.languages[lang] &&
        portal.languages[lang].instructionText
      )
        return portal.languages[lang].instructionText;
      return this.$i18n.t("home.instructionText", [this.company.fantasyName]);
    },
    phoneServiceText() {
      const lang = this.$i18n.locale;
      const portal = this.portal;
      if (
        portal &&
        portal.languages &&
        portal.languages[lang] &&
        portal.languages[lang].phoneServiceText
      )
        return portal.languages[lang].phoneServiceText;

      if (this.company.phoneService && this.company.phoneService.hasService) {
        const phone = this.company.phoneService.phone;
        return this.$i18n.t("home.phoneService", [phone]);
      }
      return "";
    },
  },
  methods: {
    getRoute(path, alt = false) {
      return Routes[`${path}${alt ? "Alt" : ""}`][this.$i18n.locale];
    },
    onImgNotFound() {
      this.bgImgNotFound = true;
    },
  },
  data() {
    return {
      Routes,
      protocol: "",
      bgImgNotFound: false,
    };
  },
};
</script>

<style scoped lang="scss"></style>
